import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { BriefStateProvider } from './lib/brief-state';
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './routes/SignIn';
import AuthSent from './routes/AuthSent';
import Dashboard from './routes/Dashboard';
import BriefNew from './routes/BriefNew';
import BriefCanvas from './routes/BriefCanvas';
import PressMoment from './routes/PressMoment';
import GenerationStatus from './routes/GenerationStatus';
import BookDetail from './routes/BookDetail';
import AuthorList from './routes/AuthorList';
import VoiceStudio from './routes/VoiceStudio';
import AuthorDetail from './routes/AuthorDetail';
import BriefIntake from './routes/BriefIntake';

export default function App() {
  return (
    <AuthProvider>
      <BriefStateProvider>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/auth/sent" element={<AuthSent />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/brief/new" element={<BriefNew />} />
            <Route path="/brief/:id" element={<BriefCanvas />} />
            <Route path="/brief/:id/press" element={<PressMoment />} />
            <Route path="/brief/:id/status" element={<GenerationStatus />} />
            <Route path="/book/:id" element={<BookDetail />} />
            <Route path="/authors" element={<AuthorList />} />
            <Route path="/authors/new" element={<VoiceStudio />} />
            <Route path="/authors/:id" element={<AuthorDetail />} />
            <Route path="/intake/:sessionId" element={<BriefIntake />} />
          </Route>

          <Route path="*" element={<ProtectedRoute />} />
        </Routes>
      </BriefStateProvider>
    </AuthProvider>
  );
}
